<template>
  <div
    class="rounded-extra-small flex-rounded bg-surface-container group relative flex grow cursor-pointer items-center gap-4 overflow-hidden px-4 py-2"
    @click="navigateToGoal"
  >
    <div class="flex grow flex-row items-center">
      <div
        class="bg-primary-container text-on-primary-container mr-4 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
      >
        <BaseIcon size="24">{{ goal.feedbackTopic.icon }}</BaseIcon>
      </div>
      <div class="flex flex-col">
        <h3 class="text-title-medium">{{ goal.feedbackTopic.title }}</h3>
        <span class="text-body-medium text-on-surface-variant -mt-0.5">
          {{ perspectiveSummary }}
        </span>
      </div>
    </div>

    <div class="flex w-56 flex-col justify-end">
      <BaseMemberAvatars
        class="bg-surface-container"
        :members="goal.coachees"
        size="32"
        :displayLimit="5"
      />
      <span class="text-body-medium text-on-surface-variant mt-0.5">
        {{ t('coaching.feedbackGoals.numberOfMembers', { count: goal.coachees.length }) }}
      </span>
    </div>
    <BaseIcon>chevron_right</BaseIcon>
    <BaseStateLayer />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseMemberAvatars from '@/core/components/base/avatar/BaseMemberAvatars.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { resolvePerspectiveLabel } from '@/core/models/perspective-label'
  import type { CoachFeedbackGoalPreview } from '../composables/use-coach-feedback-goals'

  interface Props {
    goal: CoachFeedbackGoalPreview
  }

  const props = defineProps<Props>()
  const { t } = useI18n()
  const router = useRouter()

  const perspectiveSummary = computed(() =>
    props.goal.perspectiveTargets
      .map((target) => {
        const label = resolvePerspectiveLabel(
          target.perspectiveKey,
          props.goal.feedbackTopic.perspectives,
          {
            kind: 'title',
            selfLabel: t('perspectives.self.default'),
          },
        )
        return `${label} ${target.target}`
      })
      .join(' ・ '),
  )

  const navigateToGoal = () => {
    router.push({
      name: 'coach-feedback-goal',
      params: {
        feedbackGoalId: props.goal.id,
      },
    })
  }
</script>
